import { createApi } from '@redux/createApi';
import { createSlice } from '@reduxjs/toolkit';
import { serialize } from '../../../shared/lib/serialize';

const tags = {
  getUserPk: 'getUserPk',
};

export const userSearchApi = createApi({
  reducerPath: 'userSearchApi',
  tagTypes: [tags.getUserPk],
  endpoints: (builder) => ({
    getUserPk: builder.query({
      query: (identifier) => {
        const params = {
          identifier: identifier,
        };

        return ({
          method: 'get', 
          url: `/admin/user-pk?${serialize(params)}`,
        });
      },
      providesTags: [tags.getUserPk],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
      transformResponse: (data) => {
        return data;
      },
    }),
  }),
});

export const userSearchParams = createSlice({
  name: 'userSearchParams',
  initialState: {
    identifier: '',
    result: null,
    error: null,
  },
  reducers: {
    setParams: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearResult: (state) => {
      state.result = null;
      state.error = null;
    },
  },
});

export const {
  useGetUserPkQuery,
} = userSearchApi;

export const { setParams, clearResult } = userSearchParams.actions;
export const userSearchParamsReducer = userSearchParams.reducer;
export const userSearchParamsSelector = (state) => state.userSearchParams; 